export default "/assets/4346cfbb44de456b.svg"